import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomerService } from "src/app/services/customer.service";
import Swal from "sweetalert2";
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RateBandsService } from "src/app/services/ratebands.service";
import { from, lastValueFrom } from "rxjs";
import { GeoService } from "src/app/services/geo.service";
import { FileHandlerService } from "src/app/services/file-handler.service";
import { HttpHeaders } from "@angular/common/http";
import { AppCoreService } from "src/app/services/app-core.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Utilities } from "src/app/models/utilities";
import { VendorService } from "src/app/services/vendor.service";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { CheckboxCellSelectComponent } from "../../../shared/ag-grid/cell-renderers/checkbox-select-cell.component";
import { EditViewDeleteActionsRenderer } from "../../../shared/ag-grid/cell-renderers/delete-view.component";
import { ProductService } from "src/app/services/products.service";
import { Title } from "@angular/platform-browser";
import { AWBDeleteActionsRenderer } from "../../../shared/ag-grid/cell-renderers/awb-delete.component";
import { ContractDetailComponent } from "./contractdetail/contractdetails.component";

@Component({
  selector: 'app-addcontract',
  templateUrl: './addcontract.component.html',
  styleUrls: ['./addcontract.component.scss']
})
export class AddContractComponent implements OnInit, AfterViewInit {
  contractUploadForm: FormGroup;

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };
  isFormSubmitted: boolean;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  selectedFile: File | null = null;
  customerId: number;
  contractId: number;
  periodId: number; //ratePeriod table serial id
  isAdd: boolean;

  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
    flex: 1,
    minWidth: 120
  };

  gridOptions: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 10
  }

  gridOptionsInfo: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 5
  }

  VendorServiceColumnDefs = [
    { cellRenderer: CheckboxCellSelectComponent, maxWidth: 60 },
    { headerName: 'Vendor', field: 'code', maxWidth: 120 },
    { headerName: 'Service', field: 'servicecode', filter: true },
  ];

  originAndDestinationColumnDefs = [
    { headerName: 'Type', field: 'type', maxWidth: 120 },
    { headerName: 'Country', field: 'country', maxWidth: 120 },
    { headerName: 'State', field: 'state', filter: true },
    { headerName: 'City', field: 'city', filter: true },
    {
      headerName: 'Centralized Contract',
      field: 'centralizedcontract',
      filter: true,
      cellStyle: { textAlign: 'center' },
      cellRenderer: (params: { value: boolean }) => {
        return params.value
          ? '<span class="badge badge-pill bg-success">Yes</span>'
          : '<span class="badge bg-warning">No</span>';
      }
    },
    {
      headerName: 'Action',
      field: 'id',
      cellRenderer: AWBDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      maxWidth: 140,
      type: 'origin',
      pinned: 'right'
    },
  ];

  destinationColumnDefs = [
    { headerName: 'Country', field: 'country', maxWidth: 120 },
    { headerName: 'State', field: 'state', filter: true },
    { headerName: 'City', field: 'city', filter: true },
    {
      headerName: 'Action',
      field: 'id',
      cellRenderer: AWBDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      maxWidth: 140,
      type: 'destination',
      pinned: 'right'
    },
  ];

  typeList = ['Origin', 'Destination'];
  rowData = [];
  rowDataInfo = [];
  customerList: any[] = [];
  vendorServiceRowData: any[] = [];
  checkedServiceRowData: any[] = [];
  originAndDestinationRowData: any[] = [];
  productList: any;
  vendorServiceList: any;
  vendorList: any;
  serviceList: any;
  countryList: [];
  StateList: [];
  CityList: [];
  originDetail: [];
  showProgressBar = false;
  fileId: number;
  progress = 0;
  contractFileName = '';
  contractFileURL = '';
  isOrgAndDesInfoSubmitted = false;
  currentDate: { dateString: string; dateTimeString: string; };

  columnDefs = [
    { headerName: 'Contract Code', field: 'contractcode' },
    { headerName: 'From Date', field: 'fromdate' },
    { headerName: 'To Date', field: 'todate' },
    { headerName: 'File Name', field: 'filename' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditViewDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 100,
      pinned: 'right'
    },
  ];

  userData: any;
  useEnterKey: any;


  constructor(
    private formBuilder: FormBuilder,
    private ngxLoaderService: NgxUiLoaderService,
    private route: ActivatedRoute,
    private utilities: Utilities,
    private appCoreService: AppCoreService,
    private customerService: CustomerService,
    private vendorService: VendorService,
    private rateBandsService: RateBandsService,
    private fileHandlerService: FileHandlerService,
    private productService: ProductService,
    public modalService: NgbModal,
    private geoService: GeoService,
    private titleService: Title,
    private router: Router,
  ) {
    // this.context = { componentParent: this, actionConfig: { update: true } };
    titleService.setTitle('CustomerContract');
    this.context = {
      actionConfig: { update: true },
      componentParent: this,
      componentName: 'AddContractComponent',
    }
  }

  async ngOnInit() {
    this.contractId = 0
    this.isAdd = true
    // set full width for this page
    const bodyTag = document.body;
    bodyTag.classList.add('sidebar-enable')
    bodyTag.classList.add('vertical-collpsed');
    this.customerId = this.route.snapshot.params['id'];
    this.contractUploadForm = this.formBuilder.group({
      txtFromDate: [null, Validators.required],
      txtToDate: [null, Validators.required],
      ddlProduct: [null],
      ddlVendor: [null],
      ddlContractVendors: [null],
      OriginAndDestinationdetails: this.formBuilder.group({
        ddltype: [null],
        ddlCountry: [null],
        ddlState: [null],
        ddlCity: [null],
        chkCentralizedContract: [null],
      }),
      contractFileControl: [null],
      docFileControl: [null],
    });

    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      await lastValueFrom(from(this.bindCountries()));
      this.getAllProducts();
      this.getAllVendors();
      this.getAllServiceList();
      this.getContractPeriod();
    }
  };

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.contractUploadForm) : null;
  }

  async bindCountries(): Promise<void> {
    try {
      const observable = this.geoService.GetAllCountries();
      const res = await lastValueFrom(observable);
      if (res && res.success) {
        this.countryList = res.data;
      }
    } catch (e) {
      console.error(e);
    }
  }

  onCheckSelectBoxChange(cell: any) {
    // console.log('cell',cell);
    const data = cell.rowdata
    // console.log('data', data)
    if (cell.checked) {
      this.checkedServiceRowData = this.checkedServiceRowData || [];
      this.checkedServiceRowData = [...this.checkedServiceRowData, data];
    } else {
      this.checkedServiceRowData = this.checkedServiceRowData.filter(
        item => item.code !== data.code || item.servicecode !== data.servicecode
      );

    }

    // console.log('filtered',data);
    // console.log('vendorServiceList',this.vendorServiceRowData);
  }

  async getAllVendorServices(events: any[] = [], servicedata?: any) {
    this.vendorServiceRowData = [];
    this.checkedServiceRowData = [];

    events.forEach((event) => {
      const id = event.id;

      if (id) {
        const vendorcode = this.vendorServiceList.find((item: any) => item.id === id)?.code;
        // console.log('vendorcode', vendorcode);

        try {
          this.vendorService.GetAllListByVendor({ id: id }).subscribe((res) => {
            if (res && res.success) {
              this.serviceList = res.data;
              if (this.serviceList.length > 0) {
                // Map the services to include the vendor code and service code
                const gridServiceList = this.serviceList.map(service => ({
                  code: vendorcode,
                  servicecode: service.servicename
                }));

                this.vendorServiceRowData = [...this.vendorServiceRowData, ...gridServiceList];

                if (!this.isAdd) {
                  this.checkedService(this.vendorServiceRowData, servicedata);
                }

              }
            }
          });
        } catch (error) {
          console.error('Error fetching vendor services:', error);
        }
      }
    });
  }
  async onCountryChange() {
    const countryCode: any = (this.countryList as any).filter((item: any) => item.code == this.contractUploadForm.get('OriginAndDestinationdetails').get('ddlCountry').value)[0]?.isocode;
    if (countryCode) {
      // this.contractUploadForm.controls.ddlState.reset();
      //this.contractUploadForm.controls.ddlCity.reset();
      this.contractUploadForm.get('OriginAndDestinationdetails.ddlState')?.reset();
      this.contractUploadForm.get('OriginAndDestinationdetails.ddlCity')?.reset();

      this.bindStatesByCountry(countryCode, 'origin');
    }
  }

  async AddOriginAndDestination() {
    this.contractUploadForm.get('OriginAndDestinationdetails').get('ddltype').setValidators([Validators.required]);
    this.contractUploadForm.get('OriginAndDestinationdetails').get('ddlCountry').setValidators([Validators.required]);
    this.contractUploadForm.get('OriginAndDestinationdetails').get('ddltype').updateValueAndValidity();
    this.contractUploadForm.get('OriginAndDestinationdetails').get('ddlCountry').updateValueAndValidity();

    if (this.contractUploadForm.get('OriginAndDestinationdetails').valid) {
      let newEntry = {
        type: this.contractUploadForm.get('OriginAndDestinationdetails').get('ddltype')?.value,
        country: this.contractUploadForm.get('OriginAndDestinationdetails').get('ddlCountry')?.value,
        state: this.contractUploadForm.get('OriginAndDestinationdetails').get('ddlState')?.value,
        city: this.contractUploadForm.get('OriginAndDestinationdetails').get('ddlCity')?.value,
        centralizedcontract: this.contractUploadForm.get('OriginAndDestinationdetails').get('chkCentralizedContract')?.value,
      };

      const hasExistingOrigin = this.originAndDestinationRowData.some(row => row.centralizedcontract);

      if (newEntry.centralizedcontract === true && hasExistingOrigin) {
        const confirmed = await this.openConfirmationDialog(
          'Already having an existing Centralized Contract. Do you want to replace it?'
        );

        if (confirmed) {
          // Update existing centralized contract to false
          this.originAndDestinationRowData = this.originAndDestinationRowData.map(row => ({
            ...row,
            centralizedcontract: false
          }));
        } else {
          // If not confirmed, new entry should have centralizedcontract = false
          newEntry.centralizedcontract = false;
        }
      }

      // Add the new entry to the list
      this.originAndDestinationRowData = [...this.originAndDestinationRowData, newEntry];

      // console.log(this.originAndDestinationRowData, newEntry);

      // Reset form controls
      this.contractUploadForm.get('OriginAndDestinationdetails')?.get('ddltype')?.setValue(null);
      this.contractUploadForm.get('OriginAndDestinationdetails')?.get('ddlCountry')?.setValue(null);
      this.contractUploadForm.get('OriginAndDestinationdetails')?.get('ddlState')?.setValue(null);
      this.contractUploadForm.get('OriginAndDestinationdetails')?.get('ddlCity')?.setValue(null);


      this.contractUploadForm.get('OriginAndDestinationdetails').get('ddltype').clearValidators();
      this.contractUploadForm.get('OriginAndDestinationdetails').get('ddlCountry').clearValidators();
      this.contractUploadForm.get('OriginAndDestinationdetails').get('ddltype').updateValueAndValidity();
      this.contractUploadForm.get('OriginAndDestinationdetails').get('ddlCountry').updateValueAndValidity();

      this.isOrgAndDesInfoSubmitted = false;
    }
  }




  async deleteActionDestinationAndOrigin(rowData: any, type: string) {
    const confirmed = await this.openConfirmationDialog(
      'Are you sure you want to delete ?'
    );
    if (!confirmed) return;
    const indexToRemove = this.originAndDestinationRowData.findIndex(
      (item) =>
        item.country === rowData.country &&
        item.state === rowData.state &&
        item.city === rowData.city
    );

    if (indexToRemove !== -1) {
      this.originAndDestinationRowData.splice(indexToRemove, 1);
      this.originAndDestinationRowData = [...this.originAndDestinationRowData];
    }
  }


  async onStateChange() {
    const stateCode: any = (this.StateList as any).filter((item: any) => item.code == this.contractUploadForm.get('OriginAndDestinationdetails').get('ddlState').value)[0]?.isocode;

    if (stateCode) {
      this.contractUploadForm.get('OriginAndDestinationdetails.ddlCity')?.reset();
      this.bindCitiesByState(stateCode, 'origin');
    }
  }

  async bindCitiesByState(stateCode?: string, type?: any): Promise<void> {
    try {
      if (stateCode) {
        const observable = this.geoService.GetAllCities({ statecode: stateCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          this.CityList = res.data;
        }
      }
    } catch (e) {
      console.error(e);
    }
  }



  async bindStatesByCountry(countryCode?: string, type?: any): Promise<void> {
    try {
      if (countryCode) {
        const observable = this.geoService.GetAllStates({ countrycode: countryCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          this.StateList = res.data;
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }


  async getAllProducts(): Promise<void> {
    try {
      const observable = this.productService.GetAll();
      const res = await lastValueFrom(observable);
      if (res && res.success) {
        this.productList = res.data;
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getAllServiceList(): Promise<void> {
    try {
      const observable = this.vendorService.GetAllServiceList();
      const res = await lastValueFrom(observable);
      if (res && res.success) {
        // console.log('res.data', res.data)
        this.vendorServiceList = res.data;
        // console.log('vendorServiceList', this.vendorServiceList)
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getAllVendors(): Promise<void> {
    try {
      const observable = this.vendorService.GetAll({ isactive: true });
      const res = await lastValueFrom(observable);
      if (res && res.success) {
        // console.log('res.data', res.data)
        this.vendorList = res.data;
        // console.log('vendorServiceList', this.vendorServiceList)
      }
    } catch (e) {
      console.error(e);
    }
  }

  uploadDocument() {
    let interval: any;
    let timeout: any;
    // console.log('Documentworking');
    try {
      if (this.contractUploadForm.valid) {

        if (this.selectedFile) {
          clearInterval(interval);
          clearTimeout(timeout);

          this.showProgressBar = true;
          this.progress = 0;
          interval = setInterval(() => {
            if (this.progress < 99) {
              this.progress += 1;
            }
          }, 100);
          timeout = setTimeout(() => {
            if (this.progress >= 99 && this.progress < 100) {
              this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
              this.showProgressBar = false;
              clearInterval(interval);
            }
          }, 5000);

          const resObj = {
            name: this.selectedFile.name,
            fileType: this.selectedFile.type,
            category: 'contract'
          };
          // Get signed URL and upload file
          this.fileHandlerService.GetSignedURLForUpload(resObj).subscribe(res => {
            try {
              // console.log('Signed URL response:', res);

              if (res && res.success) {
                this.progress = 100;
                clearInterval(interval);
                clearTimeout(timeout);
                setTimeout(() => {
                  this.showProgressBar = false;
                }, 1000);
                const signedUrl = res.data.uploadURL;
                this.fileId = res.data.fileId;

                // console.log('Signed URL obtained:', signedUrl);
                // console.log('File ID:', fileId);

                if (signedUrl) {
                  let headers: HttpHeaders = new HttpHeaders({
                    "Content-Type": resObj.fileType
                  });

                  // console.log('Uploading file to signed URL:', signedUrl);

                  this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                    // console.log('f',f);
                    if (f === null) {
                      // console.log('File upload response:', f);

                      this.fileHandlerService.UploadComplete({ id: this.fileId }).subscribe(async (res) => {
                        if (res && res.success) {
                          this.contractFileName = res.data.name;
                          this.contractFileURL = res.data.url;
                          this.stopProgressBar(interval, timeout);

                        } else if (res && !res.success) {
                          // console.error('Upload complete failed:', res);
                          this.stopProgressBar(interval, timeout);

                        }
                      });
                    }
                  });
                } else {
                  console.error('No signed URL returned.');
                  this.stopProgressBar(interval, timeout);

                }
              } else if (res && !res.success) {
                console.error('Failed to obtain signed URL:', res);
                this.stopProgressBar(interval, timeout);

              }
            } catch (error) {
              console.error('Error during file upload process:', error);
              this.stopProgressBar(interval, timeout);
            }
          });

        } else {
          console.log('No file selected');
        }
      }
    } catch (e) {
      console.error(e);
    }
  }



  async onDestinationStateChange() {
    const stateCode: any = (this.StateList as any).filter((item: any) => item.code == this.contractUploadForm.get('ddlDestinationState').value)[0]?.isocode;
    // const countryCode = this.rateDetailsForm.get('ddlDestinationState').value;
    if (stateCode) {
      this.contractUploadForm.controls.ddlDestinationCity.reset();
      this.bindCitiesByState(stateCode, 'destination');
    }
  }

  getContractPeriod() {
    try {
      const customerid = this.customerId;
      this.customerService.getContractDetailbyCustId(customerid).subscribe((res) => {
        if (res && res.success) {
          const data = res.data;
          // console.log('Perioddata', data);
          this.rowData = data;
        } else {
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Upload');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }


  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onGridReadyInfo(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onChangeFileSelect(evt) {
    try {
      if (evt) {
        this.selectedFile = evt.target.files[0];
      }
    } catch (e) {
      console.error(e);
    }
  }

  // async processDocument(fileId, fileName: string) {
  //   try {
  //     const requestObj = {
  //       customerid: this.contractUploadForm.controls.ddlCustomers.value,
  //       fromdate: this.contractUploadForm.controls.txtFromDate.value,
  //       todate: this.contractUploadForm.controls.txtToDate.value,
  //       docfileid: fileId
  //     }
  //     const res: any = await lastValueFrom(this.customerService.UploadDocument(requestObj));
  //     if (res && res.success && res.data?.[0]?.success_msg) {
  //       this.progress = 100;
  //       this.ngxLoaderService.stop();
  //       await this.successDialog("Record Updated successfully");
  //     } else if (res && !res.success) {
  //       this.ngxLoaderService.stop();
  //       this.appCoreService.showMessage(res.message, 'Error', 'error');
  //     }
  //   } catch (e) {
  //     this.ngxLoaderService.stop();
  //     console.error(e);
  //   }
  // }

  stopProgressBar(interval: any, timeout: any) {
    new Promise<void>((resolve) => {
      setTimeout(() => {
        this.showProgressBar = false;
        resolve();
      }, 1000);
    }).then(() => {
      clearInterval(interval);
      clearTimeout(timeout);
    });
  }

  viewAction(cell: any) {
    if (!this.permConfig.isViewAllowed) {
      this.warningDialog('No Access to View.');
    }
    else if (this.permConfig.isViewAllowed && cell) {
      // console.log('view action')
      this.ContractInfo(cell.id);
    }
  }

  ContractInfo(cell: any) {
    const modalRef = this.modalService.open(ContractDetailComponent, this.ngbModalOptions);
    modalRef.componentInstance.cell = cell;
    modalRef.componentInstance.contractVendors = this.vendorList;
    modalRef.result.then(
      (result) => {
        if (result) {
          // console.log('Closed with: result', result);
          //this.appCoreService.showMessage('Record Updated Successfully.', 'Success', 'success')
          // this.bindZoneDetailInfo(this.zoneDetailId);
        }
      },
      (reason) => {
        // console.log('Dismissed reason', reason);
        if (reason == 'Cross click') {
          // this.bindList();
        }
      }
    );

  }

  editPeriodAction(cell: any) {
    this.isAdd = false;
    this.contractId = cell.id;

    this.customerService.getContractDetailById(cell.id).subscribe(async res => {
      if (res && res.success) {
        // console.log("this contract", res.data);
        const data = res.data;
        const vendor = data[0].additionaldetails[0].vendor;
        const product = data[0].additionaldetails[0].product;
        const origin = data[0].additionaldetails[0].origin;
        const destination = data[0].additionaldetails[0].destination;
        const service = data[0].additionaldetails[0].service.map(item => item.service).flat();


        this.fileId = data[0].contractfileid;
        const contractFileUrl = data[0].contractfileurl;
        const contractFileName = data[0].contractfilename;

        // const serviceChecked = service.flatMap(item =>
        //   item.service.map(servicecode => ({
        //     code: item.vendor,
        //     servicecode: servicecode
        //   }))
        // );
        //  console.log('result',serviceChecked);

        this.contractUploadForm.get('txtFromDate')?.setValue(this.utilities.FormatDateWithTime(0, cell.fromdate).dateString);
        this.contractUploadForm.get('txtFromDate').disable();
        this.contractUploadForm.get('txtToDate')?.setValue(this.utilities.FormatDateWithTime(0, cell.todate).dateString);
        this.contractUploadForm.get('ddlProduct')?.setValue(product);
        this.contractUploadForm.get('ddlVendor')?.setValue(service);


        this.contractFileName = contractFileName;
        this.contractFileURL = contractFileUrl;
        this.originAndDestinationRowData = [...origin, ...destination];

        const vendordetail = this.contractUploadForm.get('ddlVendor')?.value;
        const vendordata = this.vendorServiceList.filter(vendor => vendordetail.includes(vendor.code));
        // console.log('vendordata',vendordata);
        // await this.getAllVendorServices(vendordata, serviceChecked);


      }
    })

  }


  async checkedService(vendorservice: any, checkedservice: any) {

    this.checkedServiceRowData = checkedservice;

    this.vendorServiceRowData = this.vendorServiceRowData.map(item => ({
      ...item,
      ischecked: checkedservice.some(
        checkedItem =>
          checkedItem.code === item.code &&
          checkedItem.servicecode === item.servicecode
      )
    }));


  }


  addContract() {
    this.isFormSubmitted = true;
    if (this.contractUploadForm.valid) {
      const selectedVendors = this.contractUploadForm.controls.ddlVendor.value || [];

      const serviceList = selectedVendors.reduce((result, service) => {
        this.vendorServiceList
          .filter((vendor) => vendor.servicename === service)
          .forEach((vendor) => {
            const existingVendor = result.find((entry) => entry.vendor === vendor.vendorname);
            existingVendor ? existingVendor.service.push(service) : result.push({ vendor: vendor.vendorname, service: [service] });
          });
        return result;
      }, []);

      const vendors = serviceList.length ? serviceList.map((data) => data.vendor) : []; // Null if no vendors selected
      const services = serviceList.length ? serviceList : []; // Empty array if no services selected

      const contractvendors = this.contractUploadForm.get('ddlContractVendors')?.value;
      const origin = this.originAndDestinationRowData.filter(item => item.type === "Origin");
      const destination = this.originAndDestinationRowData.filter(item => item.type === "Destination");

      const additional = [
        {
          product: this.contractUploadForm.controls.ddlProduct?.value,
          vendor: vendors,
          service: services,
          origin,
          destination,
          contractvendors
        }
      ];

      const requestObj = {
        id: this.contractId,
        customerid: this.customerId,
        fromdate: this.contractUploadForm.controls.txtFromDate.value,
        todate: this.contractUploadForm.controls.txtToDate.value,
        contractfileid: this.fileId,
        additionaldetails: additional
      };

      this.ngxLoaderService.start();
      if (this.permConfig.isAddAllowed && this.isAdd) {
        this.customerService.AddContract(requestObj).subscribe((res) => {
          try {
            if (res && res.success) {
              this.ngxLoaderService.stop();
              // console.log('res', res);
              this.openSuccessDialog("Record Added Sucessfully");
              this.getContractPeriod()
              this.reset();
              this.contractFileName = '';
              this.contractFileURL = '';
              this.isFormSubmitted = false;
            } else if (res && !res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage(res.message, 'Error', 'error');
            }
          } catch (err) {
            this.ngxLoaderService.stop();
            console.error(err);
          }
        });
      } else if (this.permConfig.isEditAllowed && !this.isAdd) {
        this.customerService.UpdateContract(requestObj).subscribe((res) => {
          try {
            if (res && res.success) {
              this.ngxLoaderService.stop();
              // console.log('res', res);
              this.openSuccessDialog("Record Updated Sucessfully");
              this.contractUploadForm.get('txtFromDate').enable();
              this.getContractPeriod();
              this.isAdd = true;
              this.reset();
              this.contractFileName = '';
              this.contractFileURL = '';
              this.isFormSubmitted = false;
            } else if (res && !res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage(res.message, 'Error', 'error');
            }
          } catch (err) {
            this.ngxLoaderService.stop();
            console.error(err);
          }
        });
      }
    }
  }


  async openSuccessDialog(msg: any) {
    const result = await Swal.fire({
      // title: 'Success!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {

    }
  }

  async openErrorDialog(msg: any) {
    const result = await Swal.fire({
      title: 'Error!',
      text: msg,
      icon: 'error',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {
      // this.back();
    }
  }

  reset() {
    this.vendorServiceRowData = [];
    this.originAndDestinationRowData = [];
    this.contractFileURL = null;
    this.contractFileName = null;
    this.contractUploadForm.reset({
      ddlProduct: null,
      ddlVendor: null,
      ddlOriginCountry: null,
      ddlOriginState: null,
      ddlOriginCity: null,
      ddlDestinationCountry: null,
      ddlDestinationState: null,
      ddlDestinationCity: null,
      txtFromDate: this.currentDate?.dateString,
      txtToDate: this.currentDate?.dateString,
      contractFileControl: null,
      docFileControl: null,
      ddlContractVendors: null,
      OriginAndDestinationdetails: {
        ddltype: null,
        ddlCountry: null,
        ddlState: null,
        ddlCity: null,
        chkCentralizedContract: null
      }
    });
    // Reset form state
    this.contractUploadForm.markAsPristine();
    this.contractUploadForm.markAsUntouched();
  }



  async openConfirmationDialog(msg: any) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true
    } else return false

  }

  async successDialog(msg?: any) {
    const success = await Swal.fire({
      titleText: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
    })
    if (success.isConfirmed) {
      this.isFormSubmitted = false;
      this.contractUploadForm.reset();
      this.contractUploadForm.controls.txtFromDate.setValue(this.currentDate.dateString);
      this.contractUploadForm.controls.txtToDate.setValue(this.currentDate.dateString);
    }
  }

  async warningDialog(msg?: any) {
    Swal.fire({
      titleText: 'Warning',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
    })
  }


  async deletePeriodAction(cell: any) {
    try {
      if (!this.permConfig.isDeleteAllowed) {
        this.warningDialog('No access to Delete.');
      }
      else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
        const confirmed = await this.openConfirmationDialog('Are you sure you want to delete ?');
        confirmed && this.deleteRecord(cell.id);
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.customerService.DeleteContract(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.getContractPeriod()
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Cannot delete !', 'error')
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  cancelForm() {
    this.isAdd ? this.router.navigate(['/setup/customers']) :
      this.reset();
  }

}
